import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { pageStatistics } from '@ifeng-fe/mobile_statistics';
import BottomBar from '@src/mobile/components/BottomBar';
import { isGrounds } from '@src/public/utils/app';
import { getQuery } from '@src/public/utils/url';
import { RankStore, ListStore } from './store';
import styles from './index.css';
import Rank from './Rank';
import Latest from './Latest';
import { useCloseSamePage } from '@src/public/hooks/useCloseSamePage';

const Layout = ({ content }) => {
    // page统计
    useEffect(() => {
        const from = getQuery(window.location.href, 'from') || '';

        pageStatistics({ behavior: 'page', id: 'timeline_merge', type: 'other', ref: from });
    }, []);

    useCloseSamePage();

    return (
        <ListStore.Provider>
            <RankStore.Provider>
                <div className={styles.layout}>
                    <Rank />
                    <Latest />
                    {isGrounds ? <BottomBar /> : null}
                </div>
            </RankStore.Provider>
        </ListStore.Provider>
    );
};

Layout.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Layout);
